import React from 'react';
import getName from '../../../../../../helpers/getName';

export const getOptionsBySelect = (data = [], isWorker = false) => {
  if (!data || !data.length) return [];

  if (isWorker) {
    return data?.map((worker) => {
      const name = getName(worker);
      const speciality = worker.specialityName || worker.speciality;

      let option = name;

      if (speciality) {
        option = (
          <div>
            <div
              style={{
                lineHeight: 1.1,
                fontSize: 10,
                fontWeight: 700,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              {speciality}
            </div>
            <div
              style={{
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              {name}
            </div>
          </div>
        );
      }

      return {
        ...worker,
        key: worker.id,
        value: worker.id,
        content: option || String(worker.id),
        search: name || String(worker.id),
        text: name || String(worker.id),
      };
    });
  }

  return data.map((item) => ({
    ...item,
    value: item.id,
    key: item.id,
    content: item.name || String(item.id),
    search: item.name || String(item.id),
  }));
};
